/**
 * Zod schemas for recommendation API payloads (mirrors OpenAPI components).
 */

import { z } from 'zod';

export const friendsGoingPreviewSchema = z.object({
  count: z.number().int().min(0),
  names: z.array(z.string()).max(3),
});

export const recommendationReasonSchema = z.string().max(80);

export const recommendationEventReasonsSchema = z.array(recommendationReasonSchema).max(3);

export const recommendationEventExtensionsSchema = z.object({
  reasons: recommendationEventReasonsSchema,
  friendsGoingPreview: friendsGoingPreviewSchema,
});

export type FriendsGoingPreviewValidated = z.infer<typeof friendsGoingPreviewSchema>;
